import type { UserRole } from '@/types/auth';

/**
 * The one plain-language name for each role. Every screen that shows a role
 * (People, its dialogs, the account menu, Your profile) uses this map so a
 * raw value such as "ADMIN" never reaches the page.
 */
export const userRoleLabels: Record<UserRole, string> = {
  SUPERADMIN: 'Platform owner',
  ADMIN: 'Organization administrator',
  OPERATOR: 'Operator',
  USER: 'User',
  VIEWER: 'Viewer',
  DEVICE: 'Device',
};

export const visibleUserRole = (role: UserRole): string => userRoleLabels[role];

/** The name to show for a person: full name when set, otherwise username. */
export const personDisplayName = (person: {
  full_name?: string | null;
  username: string;
}): string => person.full_name?.trim() || person.username;
